<div
  class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-gap-medium gw-overflow-hidden"
>
  <div
    class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-gap-medium gw-overflow-y-auto"
  >
    <div class="gw-flex gw-flex-col gw-gap-2x-small border-pix-bottom">
      <div class="gw-flex gw-flex-col">
        <span class="gw-text-text-secondary gw-text-base gw-font-normal">
          {{ 'features.withdrawals.modalPix.transferTo' | translate }}
        </span>
        <span
          class="gw-text-text-primary gw-text-base gw-font-extrabold gw-mt-2 gw-mb-small"
        >
          {{ reviewRecipientName | uppercase }}
        </span>
      </div>

      <span
        class="gw-text-text-secondary gw-text-base gw-mb-small gw-font-medium"
      >
        {{ 'features.withdrawals.modalPix.details' | translate }}
      </span>

      <ng-container *ngIf="isEmvReview; else transferDetails">
        <div class="gw-flex gw-flex-col gw-gap-small">
          <div
            class="gw-flex gw-items-center gw-justify-between"
            *ngIf="emvDecoded?.pixKey"
          >
            <span class="gw-text-text-primary gw-font-bold">
              {{ 'features.withdrawals.modalPix.titleField' | translate }}
            </span>
            <span
              class="gw-max-w-[60%] gw-truncate gw-text-right gw-text-text-secondary gw-font-normal"
            >
              {{ emvDecoded?.pixKey }}
            </span>
          </div>
          <div class="gw-flex gw-items-center gw-justify-between">
            <span class="gw-text-text-primary gw-font-bold">
              {{ 'features.withdrawals.modalPix.value' | translate }}
            </span>
            <span class="gw-text-text-secondary gw-font-normal">
              <ng-container *ngIf="hasEmvFixedAmount; else emvOpenAmount">
                {{
                  emvEffectiveAmount
                    | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
                }}
              </ng-container>
              <ng-template #emvOpenAmount>
                {{
                  'features.withdrawals.modalPix.emvPreviewOpenAmount'
                    | translate
                }}
              </ng-template>
            </span>
          </div>
          <div
            class="gw-flex gw-items-start gw-justify-between gw-gap-small"
            *ngIf="description?.trim()"
          >
            <span class="gw-text-text-primary gw-font-bold gw-shrink-0">
              {{ 'features.withdrawals.modalPix.descriptionLabel' | translate }}
            </span>
            <span
              class="gw-max-w-[60%] gw-whitespace-pre-wrap gw-break-words gw-text-right gw-text-text-secondary gw-font-normal"
            >
              {{ description.trim() }}
            </span>
          </div>
        </div>
      </ng-container>

      <ng-template #transferDetails>
        <div class="gw-flex gw-flex-col gw-gap-small">
          <div
            class="gw-flex gw-items-center gw-justify-between"
            *ngIf="pixRecipientResponse?.holderDocument"
          >
            <span class="gw-text-text-primary gw-font-bold">
              {{ 'features.withdrawals.modalPix.cpfCnpj' | translate }}
            </span>
            <span class="gw-text-text-secondary gw-font-normal">
              {{ pixRecipientResponse?.holderDocument | document }}
            </span>
          </div>
          <div
            class="gw-flex gw-items-center gw-justify-between"
            *ngIf="pixRecipientResponse?.agency"
          >
            <span class="gw-text-text-primary gw-font-bold">
              {{ 'features.withdrawals.modalPix.agency' | translate }}
            </span>
            <span class="gw-text-text-secondary gw-font-normal">
              {{ formatAgency(pixRecipientResponse?.agency) }}
            </span>
          </div>
          <div
            class="gw-flex gw-items-center gw-justify-between"
            *ngIf="pixRecipientResponse?.account"
          >
            <span class="gw-text-text-primary gw-font-bold">
              {{ 'features.withdrawals.modalPix.checkingAccount' | translate }}
            </span>
            <span class="gw-text-text-secondary gw-font-normal">
              {{ formatAccount(pixRecipientResponse?.account) }}
            </span>
          </div>
          <div
            class="gw-flex gw-items-start gw-justify-between gw-gap-small"
            *ngIf="description?.trim()"
          >
            <span class="gw-text-text-primary gw-font-bold gw-shrink-0">
              {{ 'features.withdrawals.modalPix.descriptionLabel' | translate }}
            </span>
            <span
              class="gw-max-w-[60%] gw-whitespace-pre-wrap gw-break-words gw-text-right gw-text-text-secondary gw-font-normal"
            >
              {{ description.trim() }}
            </span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
